
// Events
document.addEventListener('DOMContentLoaded', function() {

    const formSample = document.getElementById("form-book");

    document.querySelectorAll("[data-step]").forEach(link => {
        link.addEventListener("click", function () {
            const step = this.getAttribute("data-step");
            formSample.setAttribute("data-form-step", step);

            document.querySelectorAll(".breadcrumb-item").forEach(item => item.classList.remove("current"));
            document.querySelector('.breadcrumb-link[data-step="'+step+'"]').closest(".breadcrumb-item").classList.add("current");
        });
    });

});
